import { render, staticRenderFns } from "./SectionTrendingTopics.vue?vue&type=template&id=f7168a0e&scoped=true"
import script from "./SectionTrendingTopics.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionTrendingTopics.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SectionTrendingTopics.vue?vue&type=style&index=0&id=f7168a0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7168a0e",
  null
  
)

export default component.exports